export { default, getServerSideProps } from '@/components/pages/segmentationDetails/job';
